// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as Core from "@linaria/core";
import * as HomeMolecules from "../../molecules/home/HomeMolecules.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

function NewsletterSection(props) {
  return JsxRuntime.jsx("section", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
              children: t`Newsletter`,
              className: Core.cx("mb-6")
            }),
            JsxRuntime.jsx(HomeAtoms.SerifHeading.make, {
              children: t`Stay in touch.`,
              className: Core.cx("text-3xl md:text-4xl lg:text-5xl mb-6 leading-[1.1]")
            }),
            JsxRuntime.jsxs("p", {
              children: [
                t`Be the first to know about`,
                " ",
                JsxRuntime.jsx("span", {
                  children: t`promotions`,
                  className: Core.cx("text-gray-900")
                }),
                ", ",
                JsxRuntime.jsx("span", {
                  children: t`giveaways`,
                  className: Core.cx("text-gray-900")
                }),
                ", ",
                JsxRuntime.jsx("span", {
                  children: t`holiday sales`,
                  className: Core.cx("text-gray-900")
                }),
                ", ",
                t`and tips and tricks from our blog.`
              ],
              className: Core.cx("text-gray-700 font-light leading-relaxed max-w-md")
            })
          ],
          className: Core.cx("md:col-span-6")
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(HomeMolecules.NewsletterForm.make, {}),
          className: Core.cx("md:col-span-6 md:pt-2")
        })
      ],
      className: Core.cx("max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-start")
    }),
    className: Core.cx("w-full bg-[#f1ede4] px-6 md:px-12 py-24 md:py-32")
  });
}

let make = NewsletterSection;

export {
  make,
}
/*  Not a pure module */
